import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdUnidade: '',
    IdEmpresa: user[0].IdEmpresa,
    uniNome: '',
    uniRazaoSocial: '',
    uniCNPJ: '',
    uniLogo: '',
    uniEndereco: '',
    uniStatus: 1,
    uniObservacoes: '',
    uniCriadoPor: user[0].pesEmail,
    uniCriadoEm: newDate,
    uniAlteradoPor: user[0].pesEmail,
    uniAlteradoEm: newDate,
    uniCodigoGUID: uuidv4,
    uniSubUnidades: 0,
  })

  const [camposLocal, setCamposLocal] = useState({
    IdLocalArea: '',
    IdEmpresa: user[0].IdEmpresa,
    IdUnidade: 0,
    IdGerencia: 0,
    locDescricao: '',
    locReferencia: '',
    locStatus: 1,
    locObservacoes: '',
    locCriadoPor: user[0].pesEmail,
    locCriadoEm: newDate,
    locAlteradoPor: user[0].pesEmail,
    locAlteradoEm: newDate,
    locCodigoGUID: uuidv4
  })

  function handleInputChange(event) {
    if (event.target.name === 'uniStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else if (event.target.name === 'uniSubUnidades') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
    console.log(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    //se a unidade não terá sub unidades
    if (campos.uniSubUnidades === 0) {
      //avisa e aguarda confirmação do usuário
      if (window.confirm('Essa nova Unidade não permitirá Cadastrar Sub-Unidades (Locais). \n Deseja continuar e Salvar?')) {
        axios
          .post(
            process.env.REACT_APP_API_URL + '/api/v1/unidade',
            campos)
          .then(response => {
            //obtem unidade pelo codigo guid
            axios
              .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/unidade/guid/' +
                campos.uniCodigoGUID
              )
              .then(resp => {
                //se retornar unidade cadastra local
                if (resp.data[0]) {
                  camposLocal.IdUnidade = resp.data[0].IdUnidade
                  camposLocal.locDescricao = resp.data[0].uniNome
                  setCamposLocal(camposLocal)
                  console.log(camposLocal)
                  axios
                    .post(process.env.REACT_APP_API_URL + '/api/v1/area', camposLocal)
                    .then(respLoc => {
                      alert(response.data.message + "\n \n" + respLoc.data.message)
                      window.location.reload()
                    })
                } else {
                  alert(response.data.message + "\n \n" + resp.data.message)
                  window.location.reload()
                }
              })
          })
      } else {
        alert('Ação cancelada pelo usuário')
      }
    }
    // a unidade terá sub unidades, então apenas salva
    else {
      axios
        .post(process.env.REACT_APP_API_URL + '/api/v1/unidade', campos)
        .then(response => {
          alert(response.data.message)
          window.location.reload()
        })
    }
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Nova Unidade
      </button>

      {modal && (
        <div className="modalArea">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Nova Unidade
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <div className="lineModal">
                <label>Nome Fantasia:</label>
                <label>CNPJ:</label>
              </div>
              <div className="lineModal">
                <input
                  type="text"
                  autoComplete="nope"
                  id="fname"
                  onChange={handleInputChange}
                  name="uniNome"
                  defaultValue={campos.uniNome}
                />
                <input
                  type="text"
                  autoComplete="nope"
                  id="fname"
                  onChange={handleInputChange}
                  name="uniCNPJ"
                  defaultValue={campos.uniCNPJ}
                />
              </div>
              <label>Razão Social:</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.uniRazaoSocial}
                name="uniRazaoSocial"
                onChange={handleInputChange}
              ></input>
              <label>Endereço:</label>
              <input
                type="text"
                autoComplete="nope"
                id="fname"
                onChange={handleInputChange}
                name="uniEndereco"
                defaultValue={campos.uniEndereco}
              />
              <label>Observações:</label>
              <textarea
                type="text"
                id="fname"
                name="uniObservacoes"
                defaultValue={campos.uniObservacoes}
                row="none"
                onChange={handleInputChange}
                maxLength="500"
              ></textarea>

              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="uniStatus"
                      type="checkbox"
                      defaultChecked={!!campos.uniStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>
                <div className="InputAuthorization5">
                  <label>
                    <input
                      name="uniSubUnidades"
                      type="checkbox"
                      defaultChecked={!!campos.uniSubUnidades}
                      onChange={handleInputChange}
                    />
                    <span>Possui sub-unidades (Locais)?</span>
                  </label>
                </div>
                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
